export default function isTestPageEnable(): boolean {
  return (localStorage.getItem('we-isTestPage') ?? '') === 'true';
}
